import "./style.less";

import pngDankort from "./assets/dankort.png";
import pngMaestro from "./assets/maestro.png";
import pngMastercard from "./assets/mastercard.png";
import pngMobilepay from "./assets/mobile-pay.png";
import pngVisaElectron from "./assets/visa-electron.png";
import pngVisa from "./assets/visa.png";

export default function paymentCards() {
    return {
        restrict: "E",
        scope: {
            cardType: "=",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            $scope.getCardName = function () {
                let card = {
                    icon: new Image(),
                    title: "",
                };

                // DIBS PAYTYPES - http://tech.dibspayment.com/D2/Toolbox/Paytypes
                switch ($scope.cardType) {
                    case "MPO_Nets":
                    case "MPO_EULI":
                    case "MobilePay":
                        card.title = "MobilePay";
                        card.icon.src = pngMobilepay;

                        break;

                    case "V-DK":
                    case "DK":
                        card.title = "Dankort";
                        card.icon.src = pngDankort;

                        break;

                    case "ELEC":
                        card.title = "VISA Electron";
                        card.icon.src = pngVisaElectron;

                        break;

                    case "AMEX":
                    case "AMEX(DK)":
                    case "AMEX(SE)":
                        card.title = "American Express";
                        //card.icon.src = ?????;

                        break;

                    case "JCB":
                        card.title = "JCB";
                        card.icon.src = pngVisaElectron;

                        break;

                    case "MasterCard":
                    case "MC":
                    case "MC(DK)":
                    case "MC(SE)":
                    case "MC(YX)":
                        card.title = "Mastercard";
                        card.icon.src = pngMastercard;

                        break;

                    case "MTRO":
                    case "MTRO(DK)":
                    case "MTRO(SE)":
                    case "MTRO(UK)":
                        card.title = "Maestro";
                        card.icon.src = pngMaestro;

                        break;

                    case "Visa":
                    case "VISA":
                    case "VISA (SE)":
                        card.title = "VISA";
                        card.icon.src = pngVisa;

                        break;

                    default:
                }

                $scope.card = card;
            };

            $scope.getCardName();
        },
    };
}
